import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-dialog',
  template: `
    <div class="dialog-container">
      <mat-icon class="warning-icon">warning</mat-icon>
      
      <h2 mat-dialog-title>Confirmación</h2>
      
      <mat-dialog-content>
        <p>{{data.message}}</p>
      </mat-dialog-content>
      
      <mat-dialog-actions>
        <button mat-stroked-button class="btn-cancel" (click)="onNoClick()">
          No
        </button>
        <button mat-flat-button color="warn" [mat-dialog-close]="true">
          Sí
        </button>
      </mat-dialog-actions>
    </div>
  `,
  styles: [`
    .dialog-container {
      padding: 20px;
      text-align: center;
    }

    .warning-icon {
      font-size: 40px;
      height: 40px;
      width: 40px;
      color: #f44336;
      margin-bottom: 12px;
    }

    h2 {
      margin: 0;
      font-size: 18px;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.87);
      margin-bottom: 8px;
    }

    p {
      margin: 0;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.6);
      line-height: 1.5;
      margin-bottom: 20px;
    }

    mat-dialog-actions {
      padding: 0;
      margin: 0;
      min-height: 0;
      display: flex;
      justify-content: center;
      gap: 12px;
    }

    button {
      min-width: 80px;
      font-weight: 500;
    }

    .btn-cancel {
      color: rgba(0, 0, 0, 0.6);
    }
  `]
})
export class ConfirmDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string }
  ) {
    // Configurar el diálogo para que no se cierre al hacer clic fuera
    this.dialogRef.disableClose = true;
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
} 